import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Image } from 'react-bootstrap';
import dokumentasjonsEksempel from '../../images/Skjermbilde 2024-01-30 kl. 00.36.39.png';
import dokuModuleCSS from './doku.module.css';

function DokumentasjonsModal() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
            <Button className={dokuModuleCSS.button} variant="primary" onClick={handleShow}>
                2023
            </Button>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                <Modal.Title>Dokumentasjon</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="container dokumentasjons-modal">
                        <div className="row">
                            <div className="col-12">
                                <Image src={dokumentasjonsEksempel} fluid alt="dokumentasjon" />
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                <Button className={dokuModuleCSS.button} variant="primary" onClick={handleClose}>
                    Lukk
                </Button>
                </Modal.Footer>
            </Modal>
    </>
  );
}

export default DokumentasjonsModal;